import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import getUserLocale from 'get-user-locale';

import { environment } from '../../../environments/environment';
import { StaticService } from '../../i18n/services';

@Injectable({
	providedIn: 'root'
})
export class LanguageService {
	constructor(@Inject(LOCALE_ID) protected locale: string, private staticService: StaticService) {}

	/**
	 * Validate provided locale either against account languages or build languages and ensure app is running in the correct
	 * language. If not, redirect user to correct app language version and return false.
	 *
	 * @param userLocale Preferred locale, will default to getting language out of browser
	 */
	public validateAppLanguage(locale: string): boolean {
		const userLocale = this.accountLocale(locale).toLocaleLowerCase();

		if (location.origin.indexOf('localhost:4200') === -1 && environment.production && userLocale !== this.locale.toLowerCase()) {
			this.updateAppLocale(userLocale);
			return false;
		}

		return true;
	}

	/**
	 * Validates provided locale against account supported languages and find the closest
	 * match (i.e. if 'en-GB' not found return 'en'). This is the list of languages we have
	 * full translations for and allow accounts be created and set against.
	 *
	 * @param locale Locale to validate, defaults to users browser locale
	 */
	public accountLocale(locale = getUserLocale()): string {
		return this.staticService.has('languages', locale)
			? locale
			: this.staticService.has('languages', locale.split('-')[0])
			? locale.split('-')[0]
			: 'en';
	}

	/**
	 * Update locale URL and redirect user.
	 *
	 * @param locale Locale to use
	 * @param redirectTo Redirect URL
	 */
	private updateAppLocale(locale: string): void {
		const path = window.location.pathname.split('/');

		// Remove locale
		path.splice(0, 2);

		window.location.replace(`/${locale}/${path.join('/')}${window.location.search}`);
	}
}
